import React from 'react';

function Lattice() {
  return (
    <>
      <header className="AppHeader">Lattice</header>
      <main className="TileContainer">
        <div className="Tile">
          <h2>Lattice Project</h2>
          <p>This is the Lattice page at /micros/lattice</p>
        </div>
      </main>
    </>
  );
}

export default Lattice;